<template>
  <b-row>
    <b-col>
      <hr>
      <b-alert show variant="warning">
        Upload is taking a long time due to large file size or slow internet speed.
        You can cancel the upload and try again later when a better connection is available.
      </b-alert>
      <div class="text-right mt-2">
        <b-button
          class="button-danger raised"
          @click="cancel"
        >Cancel</b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CancelUpload',
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/upload/CancelUpload.vue